export const DATE_FORMAT = 'HH:mm dd/MM/yy';
